module.exports = __webpack_public_path__ + "static/media/PH.7cad4c29.svg";